import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/sino-auctionMessage/auctionMessage/list',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        }
    })
}


export const hallMessage = (params) => {
    return request({
        url: '/api/sino-auctionMessage/auctionMessage/hallMessage',
        method: 'get',
        params: {
            ...params
        }
    })
}

export const getDetail = (id) => {
    return request({
        url: '/api/sino-auctionMessage/auctionMessage/detail',
        method: 'get',
        params: {
            id
        }
    })
}

export const remove = (ids) => {
    return request({
        url: '/api/sino-auctionMessage/auctionMessage/remove',
        method: 'post',
        params: {
            ids,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/sino-auctionMessage/auctionMessage/submit',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/sino-auctionMessage/auctionMessage/submit',
        method: 'post',
        data: row
    })
}

